import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class IssueWebService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }
    public ExportXLS(accountId: number, siteId: number, statusId: number, contactId: number, issueType1Id: number, issueType2Id: number, issueType3Id: number, searchText: string, fromDateString: string, toDateString: string) {

        let url = `Issue/ExportXLS?accountId=${accountId}&siteId=${siteId}&statusId=${statusId}&contactId=${contactId}&issueType1Id=${issueType1Id}&issueType2Id=${issueType2Id}&issueType3Id=${issueType3Id}&searchText=${searchText}&fromDateString=${fromDateString}&toDateString=${toDateString}`;
        return super.savePDF<any>(url, 'application/pdf');
    }
    public getIssues(data): Observable<IPagedResults<any>> {
        let url = `Issue/GetAll`;
        return super.save<any>(url, data);
    }

    public downloadCSV(data): Observable<any> {
        let url = `Issue/DownloadCSV`;
        return super.download(url, "text/csv", "export.csv");
    }

    public getIssue(id: number) {
        let url = `Issue/Get?id=${id}`;
        return super.getById<any>(url);
    }
    public GetByGuid(id: any) {
        let url = `Issue/GetByGuid?guid=${id}`;
        return super.getById<any>(url);
    }

    public GetIssueDropdowns(accountId: number, siteId: number) {
        let url = `Issue/GetIssueDropdowns?accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);;
    }

    public getIssueLog(id: number, showHidden?: boolean) {
        let url = `Issue/GetLogs?issueWebId=${id}&showHidden=${showHidden}`;
        return super.getAll<any>(url);
    }

    public saveIssue(data, saveIssue?: boolean) {
        let url = `IssueWeb/Save`;

        if (saveIssue) {
            return super.save<any>(url, data, { "SaveIssue": "true" });
        }

        return super.save<any>(url, data);
    }

    public closeIssue(data) {
        let url = `IssueWeb/CloseIssue`;
        return super.save<any>(url, data);
    }
    public reOpenIssue(data) {
        let url = `IssueWeb/ReOpenIssue`;
        return super.save<any>(url, data);
    }

    public saveIssueLog(data) {
        let url = `IssueWeb/SaveLog`;
        return super.save<any>(url, data);
    }

    public sendDetails(data) {
        let url = `IssueWeb/SendDetails`;
        return super.save<any>(url, data);
    }

    public confirm(data) {
        let url = `IssueWeb/Confirm`;
        return super.save<any>(url, data);
    }

    public deleteIssue(data) {
        let url = `IssueWeb/Delete`;
        return super.save<any>(url, data);
    }

    public sendReminder(data) {
        let url = `Issue/Reminder`;
        return super.save<any>(url, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/issue-web.service.ts